/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TabsRouteImport } from './routes/_tabs'
import { Route as TabsCollectionRouteImport } from './routes/_tabs/collection'
import { Route as TabsHomeRouteImport } from './routes/_tabs/home'
import { Route as TabsMyRecoRouteImport } from './routes/_tabs/my-reco'
import { Route as TabsProfileRouteImport } from './routes/_tabs/profile'
import { Route as TabsRecoShareRouteImport } from './routes/_tabs/reco-share'
import { Route as TabsRecommendationRouteImport } from './routes/_tabs/recommendation'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as InviteCodeRouteImport } from './routes/invite.$code'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TabsRoute = TabsRouteImport.update({
  id: '/_tabs',
  getParentRoute: () => rootRouteImport,
} as any)
const TabsCollectionRoute = TabsCollectionRouteImport.update({
  id: '/collection',
  path: '/collection',
  getParentRoute: () => TabsRoute,
} as any)
const TabsHomeRoute = TabsHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => TabsRoute,
} as any)
const TabsMyRecoRoute = TabsMyRecoRouteImport.update({
  id: '/my-reco',
  path: '/my-reco',
  getParentRoute: () => TabsRoute,
} as any)
const TabsProfileRoute = TabsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => TabsRoute,
} as any)
const TabsRecoShareRoute = TabsRecoShareRouteImport.update({
  id: '/reco-share',
  path: '/reco-share',
  getParentRoute: () => TabsRoute,
} as any)
const TabsRecommendationRoute = TabsRecommendationRouteImport.update({
  id: '/recommendation',
  path: '/recommendation',
  getParentRoute: () => TabsRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteCodeRoute = InviteCodeRouteImport.update({
  id: '/invite/$code',
  path: '/invite/$code',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/collection': typeof TabsCollectionRoute
  '/home': typeof TabsHomeRoute
  '/my-reco': typeof TabsMyRecoRoute
  '/profile': typeof TabsProfileRoute
  '/reco-share': typeof TabsRecoShareRoute
  '/recommendation': typeof TabsRecommendationRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/invite/$code': typeof InviteCodeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/collection': typeof TabsCollectionRoute
  '/home': typeof TabsHomeRoute
  '/my-reco': typeof TabsMyRecoRoute
  '/profile': typeof TabsProfileRoute
  '/reco-share': typeof TabsRecoShareRoute
  '/recommendation': typeof TabsRecommendationRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/invite/$code': typeof InviteCodeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_tabs': typeof TabsRouteWithChildren
  '/_tabs/collection': typeof TabsCollectionRoute
  '/_tabs/home': typeof TabsHomeRoute
  '/_tabs/my-reco': typeof TabsMyRecoRoute
  '/_tabs/profile': typeof TabsProfileRoute
  '/_tabs/reco-share': typeof TabsRecoShareRoute
  '/_tabs/recommendation': typeof TabsRecommendationRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/invite/$code': typeof InviteCodeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/collection'
    | '/home'
    | '/my-reco'
    | '/profile'
    | '/reco-share'
    | '/recommendation'
    | '/auth/callback'
    | '/auth/login'
    | '/invite/$code'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/collection'
    | '/home'
    | '/my-reco'
    | '/profile'
    | '/reco-share'
    | '/recommendation'
    | '/auth/callback'
    | '/auth/login'
    | '/invite/$code'
  id:
    | '__root__'
    | '/'
    | '/_tabs'
    | '/_tabs/collection'
    | '/_tabs/home'
    | '/_tabs/my-reco'
    | '/_tabs/profile'
    | '/_tabs/reco-share'
    | '/_tabs/recommendation'
    | '/auth/callback'
    | '/auth/login'
    | '/invite/$code'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TabsRoute: typeof TabsRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthLoginRoute: typeof AuthLoginRoute
  InviteCodeRoute: typeof InviteCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_tabs': {
      id: '/_tabs'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof TabsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_tabs/collection': {
      id: '/_tabs/collection'
      path: '/collection'
      fullPath: '/collection'
      preLoaderRoute: typeof TabsCollectionRouteImport
      parentRoute: typeof TabsRoute
    }
    '/_tabs/home': {
      id: '/_tabs/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof TabsHomeRouteImport
      parentRoute: typeof TabsRoute
    }
    '/_tabs/my-reco': {
      id: '/_tabs/my-reco'
      path: '/my-reco'
      fullPath: '/my-reco'
      preLoaderRoute: typeof TabsMyRecoRouteImport
      parentRoute: typeof TabsRoute
    }
    '/_tabs/profile': {
      id: '/_tabs/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof TabsProfileRouteImport
      parentRoute: typeof TabsRoute
    }
    '/_tabs/reco-share': {
      id: '/_tabs/reco-share'
      path: '/reco-share'
      fullPath: '/reco-share'
      preLoaderRoute: typeof TabsRecoShareRouteImport
      parentRoute: typeof TabsRoute
    }
    '/_tabs/recommendation': {
      id: '/_tabs/recommendation'
      path: '/recommendation'
      fullPath: '/recommendation'
      preLoaderRoute: typeof TabsRecommendationRouteImport
      parentRoute: typeof TabsRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$code': {
      id: '/invite/$code'
      path: '/invite/$code'
      fullPath: '/invite/$code'
      preLoaderRoute: typeof InviteCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface TabsRouteChildren {
  TabsCollectionRoute: typeof TabsCollectionRoute
  TabsHomeRoute: typeof TabsHomeRoute
  TabsMyRecoRoute: typeof TabsMyRecoRoute
  TabsProfileRoute: typeof TabsProfileRoute
  TabsRecoShareRoute: typeof TabsRecoShareRoute
  TabsRecommendationRoute: typeof TabsRecommendationRoute
}

const TabsRouteChildren: TabsRouteChildren = {
  TabsCollectionRoute: TabsCollectionRoute,
  TabsHomeRoute: TabsHomeRoute,
  TabsMyRecoRoute: TabsMyRecoRoute,
  TabsProfileRoute: TabsProfileRoute,
  TabsRecoShareRoute: TabsRecoShareRoute,
  TabsRecommendationRoute: TabsRecommendationRoute,
}

const TabsRouteWithChildren = TabsRoute._addFileChildren(TabsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TabsRoute: TabsRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthLoginRoute: AuthLoginRoute,
  InviteCodeRoute: InviteCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
